export default class FiltroProdutoCliente {
    constructor () {
        this.Id = undefined;
        this.UnidadeId = undefined;
        this.ClienteId = undefined;
        this.ProdutoId = undefined;
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        // this.DescricaoProduto = undefined;
        this.DataUltimaVendaMin = undefined;
        this.DataUltimaVendaMax = undefined;
        this.DataUltimoFaturamentoMin = undefined;
        this.DataUltimoFaturamentoMax = undefined;
        this.Status = undefined;
        this.SegmentoProdutoEstoque = undefined;
        this.ConsultarDadosClienteAgrupador = undefined;
        this.Ordenacao = undefined;
    }
}